import { Injectable } from '@angular/core';
import type {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import type { Observable } from 'rxjs';

@Injectable()
export class CacheBusterInterceptor implements HttpInterceptor {

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.apiBaseUrl)) {
      const httpRequest = req.clone({
        headers: req.headers
          .set('Cache-Control', 'no-cache, no-store')
          .set('Pragma', 'no-cache')
          .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT'),
      });

      return next.handle(httpRequest);
    }

    return next.handle(req);
  }

}
